import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type AppButtonVariant = 'primary' | 'secondary' | 'ghost' | 'link' | 'danger' | 'success' | 'soft';
export type AppButtonSize = 'sm' | 'md';

/** Usage: project a label and select a variant; loading and disabled block activation. */
@Component({
  selector: 'app-button',
  templateUrl: './app-button.component.html',
  styleUrls: ['./app-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppButtonComponent {
  @Input() variant: AppButtonVariant = 'primary';
  @Input() size: AppButtonSize = 'md';
  @Input() iconLeft = '';
  @Input() iconRight = '';
  @Input() colorOverride = '';
  @Input() loading = false;
  @Input() disabled = false;
  @Input() block = false;
  @Input() neutralOutline = false;
  @Input() disabledTone: 'default' | 'neutral' = 'default';
  @Input() exposeDisabledState = false;
  @Input() reflectDisabledAttribute = false;
  @Input() successEmphasis = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() ariaLabel = '';
  @Output() clicked = new EventEmitter<MouseEvent>();

  get fill(): 'solid' | 'outline' | 'clear' {
    if (this.variant === 'secondary') {
      return 'outline';
    }
    return this.variant === 'ghost' || this.variant === 'link' ? 'clear' : 'solid';
  }

  get color(): string {
    if (this.colorOverride) {
      return this.colorOverride;
    }
    if (this.variant === 'danger') {
      return 'danger';
    }
    if (this.variant === 'success') {
      return 'success';
    }
    return 'primary';
  }

  onClick(event: MouseEvent): void {
    if (!this.disabled && !this.loading) {
      this.clicked.emit(event);
    }
  }
}
